<template>
  <div class="bg-box">
    <img src="https://img.xinjiaoyu.com/app/mobile-bg.png" />
    <router-link :to="{ name: 'download_tercher' }" class="teacher">
      下载教师端APP
      <!-- <a href="http://dist.xinjiaoyu.com/app/teacher.html" class="teacher">下载教师端APP</a> -->
    </router-link>
    <router-link :to="{ name: 'download_student' }" class="student">
      下载学生端APP
      <!-- <a href="http://dist.xinjiaoyu.com/app/student.html" class="student">下载学生端APP</a> -->
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    document.body.style.overflow = 'auto';
  },
  methods: {},
};
</script>
<style lang="less" scoped>
html,
body {
  overflow-y: auto !important;
}
.bg-box {
  position: relative;
  min-height: 100vh;
  font-size: 0;
  & > img {
    width: 100%;
  }
}
a {
  position: absolute;
  left: 25px;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  color: #3d83fc;
  font-size: 14px;
  text-align: center;
  background: #fff;
  border-radius: 2px;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}
.teacher {
  top: 185px;
}
.student {
  top: 232px;
}
</style>
